import React from 'react';
import { Grid,  Typography, Link } from "@material-ui/core";
import '../../App.css'
import { ThemeProvider } from '@material-ui/styles';
import Container from '@material-ui/core/Container';
import theme from '../../theme';
import globalUseStyles from '../../styleHooks';
import { Link as RouterLink } from 'react-router-dom';
import Slider from 'infinite-react-carousel';
import homeClasses from './homeStyles.js'
import {FiArrowLeftCircle, FiArrowRightCircle} from 'react-icons/fi';


function Work() {
  const globalClasses = globalUseStyles();
  const homeStyles = homeClasses();

    return (
    <ThemeProvider theme={theme}>

    <Container className={globalClasses.containerTopPadding} maxWidth={false} component="section">
          <Grid className={globalClasses.containerCarouselSmall} container >
            <Grid item xs={12} md={10} >
                <Typography variant="subtitle1">Case Studies</Typography>
                <Typography variant="h2">Our Work</Typography>
                <Typography variant="body1">Explore some of the projects we’ve worked on recently to get a feel for our process.</Typography>
            </Grid>
            <Grid item xs={false} md={2}/>
          </Grid>
      </Container>
    <Slider dots >
      <div >
        <Container disableGutters maxWidth={false} component="section">
          <Grid className={globalClasses.containerCarouselSmall} container >
                <Grid item xs={12} md={12} container>
                    <Grid style={{marginLeft: '-10px'}} item xs={12} md={6} container>
                      <Grid item xs={12} md={12} className={homeStyles.rciImg} />
                    </Grid>
                    <Grid item xs={12} md={6} className={globalClasses.cardCarouselStyle}>
                      <Typography variant="h3" >The Rosalyn Carter Institute for Caregivers (RCI)</Typography>
                      <Typography variant="body1" >RCI has been collecting wealth of data on caregivers in paper forms and assessments but has never had a technology solution that could collect such data electronically, aggregate the information, and provide business analytics to drive the direction of their organization and programming. </Typography>
                      <Typography variant="body1" >
                      <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                      </Typography>
                    </Grid>
                <Grid item xs={false} md={1} />
                </Grid>
              </Grid>
          </Container>
        </div>
        <div>
          <Container disableGutters maxWidth={false} component="section">
            <Grid className={globalClasses.containerCarouselSmall} container >
                  <Grid item xs={12} md={12} container>
                      <Grid style={{marginLeft: '-10px'}} item xs={12} md={6} container>
                        <Grid item xs={12} md={12} className={homeStyles.ashaImg} />
                      </Grid>
                      <Grid item xs={12} md={6} className={globalClasses.cardCarouselStyle}>
                        <Typography variant="h3" >ASHA’s National Outcomes Measurement System (NOMS)</Typography>
                        <Typography variant="body1" >ASHA NOMS is a data collection and reporting system that demonstrates the value of Speech-Language Pathology and audiology services. Integrated with EHRs, this tool allows providers to track progress in patients and aggregates data so that the field can make informed decisions on patient outcomes.</Typography>
                        <Typography variant="body1" >
                        <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                        </Typography>
                      </Grid>
                  </Grid>
                </Grid>
           </Container>
        </div>
        <div>
          <Container disableGutters maxWidth={false} component="section">
            <Grid className={globalClasses.containerCarouselSmall} container >
                  <Grid item xs={12} md={12} container>
                      <Grid style={{marginLeft: '-10px'}} item xs={12} md={6} container>
                        <Grid item xs={12} md={12} className={homeStyles.ahrqImg} />
                      </Grid>
                      <Grid item xs={12} md={6} className={globalClasses.cardCarouselStyle}>
                        <Typography variant="h3" >Agency for Healthcare Research and Quality: Quality Indicators (QI)</Typography>
                        <Typography variant="body1" >AHRQ’s Quality Indicators (QI) are measures of health care quality that make use of readily available hospital administrative data and are used by organizations with the support of a Windows based software (WinQI) or SAS (SAS QI) software.</Typography>
                        <Typography variant="body1" >
                        <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                        </Typography>
                    </Grid>
                </Grid>
              </Grid>
          </Container>
        </div>
        <div>
          <Container disableGutters maxWidth={false} component="section">
            <Grid className={globalClasses.containerCarouselSmall} container >
                  <Grid item xs={12} md={12} container>
                      <Grid item xs={12} md={6} container>
                        <Grid item xs={12} md={12} className={homeStyles.ahrqImg2} />
                      </Grid>
                      <Grid item xs={12} md={6} className={globalClasses.cardCarouselStyle}>
                        <Typography variant="h3" >Agency for Healthcare Research and Quality: Patient Safety Network (PSNet)</Typography>
                        <Typography variant="body1" >The PSNet website a one-stop-shop for research in the field of patient safety, both aggregating content from other academic sites as well as producing its own expert content in the field.</Typography>
                        <Typography variant="body1" >
                        <Link to='/case' className={"link link--arrowed"} color="primary" component={RouterLink}>View Case Study
                          <svg class="arrow-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
                            <g fill="none" stroke="#B64C4C" stroke-width="2" stroke-linejoin="round" stroke-miterlimit="10">
                              <circle class="arrow-icon--circle" cx="16" cy="16" r="15.12"></circle>
                              <path class="arrow-icon--arrow" d="M16.14 9.93L22.21 16l-6.07 6.07M8.23 16h13.98"></path>
                            </g>
                          </svg>
                      </Link>
                        </Typography>
                      </Grid>
                  </Grid>
                </Grid>
            </Container>
        </div>
      </Slider>
    <Container className={globalClasses.containerTopPadding} maxWidth={false} />
  </ThemeProvider>
  );
};

export default Work;